import styled, { css, CSSProperties } from 'styled-components';
import { cpdsMediaQueryVals } from 'components/common/cpds/token/shared/common';
import { ItemProps } from 'components/common/cpds/cpds-grid-system/typings';

 // Define the order of breakpoints from smallest to largest
 const breakpointOrder = ['sm', 'md', 'lg', 'xl'];

// Helper function to get grid-column dynamically
// const getGridColumns1 = (gridColumn: ItemProps['gridColumn'], type: keyof ItemProps['gridColumn']) => {  
//   const gColumn = type === 'sm' ? gridColumn?.[type] : gridColumn?.['xl'] ?? gridColumn?.['lg'] ?? gridColumn?.['md'];
//   console.log('gColumn', gColumn, type);
//   return gColumn ? gColumn?.start == '0' ? ` span ${gColumn?.end || 'auto'}` : `${gColumn?.start || 'auto'} / span ${gColumn?.end || 'auto'}` : 'auto / auto';
// }

const getGridColumns = (gridColumn: ItemProps['gridColumn'], type: keyof ItemProps['gridColumn']) => {  
  // Find the index of the current type (sm, md, lg, xl)
  const currentIndex = breakpointOrder.indexOf(type);
  
  // Try to find the nearest value from the provided type and fallbacks in descending order
  let gColumn = null;
  for (let i = currentIndex; i < breakpointOrder.length; i++) {
    gColumn = gridColumn?.[breakpointOrder[i]];
    if (gColumn) break;
  } 
  // Return the formatted grid-column values
  return gColumn 
    ? gColumn.start === '0' 
      ? `span ${gColumn?.span || 'auto'}` 
      : `${gColumn?.start || 'auto'} / span ${gColumn?.span || 'auto'}`
    : 'auto / auto';
}

// Helper function to get grid-row dynamically
const getGridRows = (gridRow: ItemProps['gridRow'], type: keyof ItemProps['gridRow']) => {
 // Find the index of the current type (sm, md, lg, xl)
 const currentIndex = breakpointOrder.indexOf(type);
  
 // Try to find the nearest value from the provided type and fallbacks in descending order
 let gRow = null;
 for (let i = currentIndex; i < breakpointOrder.length; i++) {
  gRow = gridRow?.[breakpointOrder[i]];
   if (gRow) break;
 } 

   // Return the formatted grid-column values
   return gRow 
   ? gRow.start === '0' 
     ? `span ${gRow?.span || 'auto'}` 
     : `${gRow?.start || 'auto'} / span ${gRow?.span || 'auto'}`
   : 'auto / auto';
}

export const Item = styled.div.attrs<ItemProps>(({ dataCy, className }) => ({
  'data-cy': dataCy,
  className: className,
}))<ItemProps>`
  grid-column: ${({ gridColumn }) => getGridColumns(gridColumn, 'xl')};
  grid-row: ${({ gridRow }) => getGridRows(gridRow, 'xl')};

  /* Large screens (1280px - 1679px) */
  @media (max-width: ${cpdsMediaQueryVals.cpds_large_upper_limit}) and (min-width: ${cpdsMediaQueryVals.cpds_large_lower_limit}) {
    grid-column: ${({ gridColumn }) => getGridColumns(gridColumn, 'lg')};
    grid-row: ${({ gridRow }) => getGridRows(gridRow, 'lg')};
  }

  /* Medium screens (768px - 1279px) */
  @media (max-width: ${cpdsMediaQueryVals.cpds_medium_upper_limit}) and (min-width: ${cpdsMediaQueryVals.cpds_medium_lower_limit}) {
    grid-column: ${({ gridColumn }) => getGridColumns(gridColumn, 'md')};
    grid-row: ${({ gridRow }) => getGridRows(gridRow, 'md')};
  }

  /* Small screens (less than 768px) */
  @media (max-width: ${cpdsMediaQueryVals.cpds_small_upper_limit}) {
    grid-column: ${({ gridColumn }) => getGridColumns(gridColumn, 'sm')};
    grid-row: ${({ gridRow }) => getGridRows(gridRow, 'sm')};
  }

  /* Apply styleOverrides if passed */
  ${({ styleOverrides }) =>
    styleOverrides &&
    css`
      ${Object.entries(styleOverrides)
        .map(([key, value]) => {
          if (key.startsWith('@media')) {
            // Handle media queries
            return `
              ${key} {
                ${Object.entries(value as CSSProperties)
                  .map(([prop, val]) => `${prop}: ${val};`)
                  .join('')}
              }
            `;
          } else {
            // Handle regular CSS properties
            return `${key}: ${value};`;
          }
        })
        .join('')}
    `}
`;